import { IUserData } from '../api/b2b/users';
import { isSsr } from './general';

export const getAuthorizationToken = (): string =>
  !isSsr ? window.THDCustomer?.default?.token || '' : '';

export const isLoggedIn = (): boolean =>
  window.THDCustomer?.default?.isLoggedIn || false;

export const isB2BUser = (): boolean =>
  window.THDCustomer?.default?.isB2BCustomer || false;

export const sortUsers = (users: IUserData[]) => {
  // Sorting users by last name
  return users.slice().sort((first, second) => {
    const aLastName = (first.lastName || '').toLowerCase();
    const bLastName = (second.lastName || '').toLowerCase();
    return aLastName.localeCompare(bLastName);
  });
};
